import { render } from "./ColumnSort.vue?vue&type=template&id=27007106"
import script from "./ColumnSort.vue?vue&type=script&lang=js"
export * from "./ColumnSort.vue?vue&type=script&lang=js"

import exportComponent from "E:\\xampp7\\htdocs\\rnd_2023_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__